<template>
  <div class="content-area specifications-list">
    <hero-bar>
      {{ $t('specifications') }}

      <b-tooltip slot="right" :label="$t('refresh')" type="is-dark" position="is-bottom">
        <b-button
          id="refresh-button"
          class="mr-10"
          size="is-circle"
          type="is-link"
          outlined
          :class="{ 'is-loading': refreshLoading }"
          icon-left="refresh"
          @click="refresh"
        />
      </b-tooltip>

      <b-button
        v-if="checkPermission('create_specification')"
        id="new-plan"
        slot="right"
        tag="router-link"
        :to="{ name: 'specifications.create', query: { type: activeTab }}"
        icon-left="plus-circle"
        type="is-link"
      >
        {{ $t('createSpecification') }}
      </b-button>
    </hero-bar>

    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <b-tabs
          v-if="checkPermission('list_specifications')"
          v-model="activeTab"
          :animated="false"
          :destroy-on-hide="false"
        >
          <b-tab-item label="Görev Türü" icon="table">
            <smart-table
              ref="dutyTypesTable"
              data-url="specifications"
              :params="{ type: 1 }"
              :sort="{
                defaultOrder: 'desc',
                field: 'id',
                order: 'asc',
              }"
              :loading.sync="refreshLoading"
            >
              <template slot="action-column" slot-scope="{ row }">
                <b-table-column custom-key="actions" width="110">
                  <b-tooltip v-if="checkPermission('delete_specification')" :label="$t('delete')" type="is-dark" position="is-right">
                    <b-button
                      outlined
                      size="is-small"
                      class="button-green is-danger mr-5 only-icon"
                      icon-left="close-circle"
                      @click="deleteSpecification(row.id)"
                    />
                  </b-tooltip>
                  <b-button
                    v-if="checkPermission('edit_specification')"
                    outlined
                    size="is-small"
                    class="button-purble btn-details"
                    icon-left="arrow-right-bold"
                    tag="router-link"
                    :to="{ name: 'specifications.edit', params: { id: row.id }}"
                  >
                    {{ $t('edit') }}
                  </b-button>
                </b-table-column>
              </template>
              <template slot="header-right">
                <b-tooltip :label="$t('exportExcel')" type="is-dark" position="is-left">
                  <b-button
                    class="filter-button is-hidden-mobile"
                    size="is-circle"
                    icon-left="file-excel"
                    @click="activeTable.excelExport()"
                  />
                </b-tooltip>
              </template>
            </smart-table>
          </b-tab-item>

          <b-tab-item label="Talep Eden Birim" icon="format-list-bulleted-square">
            <smart-table
              ref="requestUnitsTable"
              data-url="specifications"
              :params="{ type: 2 }"
              :sort="{
                defaultOrder: 'desc',
                field: 'id',
                order: 'asc',
              }"
              :loading.sync="refreshLoading"
            >
              <template slot="action-column" slot-scope="{ row }">
                <b-table-column custom-key="actions" width="110">
                  <b-tooltip :label="$t('delete')" type="is-dark" position="is-right">
                    <b-button
                      outlined
                      size="is-small"
                      class="button-green is-danger mr-5 only-icon"
                      icon-left="close-circle"
                      @click="deleteSpecification(row.id)"
                    />
                  </b-tooltip>
                  <b-button
                    outlined
                    size="is-small"
                    class="button-purble btn-details"
                    icon-left="arrow-right-bold"
                    tag="router-link"
                    :to="{ name: 'specifications.edit', params: { id: row.id }}"
                  >
                    {{ $t('edit') }}
                  </b-button>
                </b-table-column>
              </template>

              <template slot="header-right">
                <b-tooltip :label="$t('exportExcel')" type="is-dark" position="is-left">
                  <b-button
                    class="filter-button is-hidden-mobile"
                    size="is-circle"
                    icon-left="file-excel"
                    @click="activeTable.excelExport()"
                  />
                </b-tooltip>
              </template>
            </smart-table>
          </b-tab-item>

          <b-tab-item label="Talep Türü" icon="table">
            <smart-table
              ref="serviceTypesTable"
              data-url="specifications"
              :params="{ type: 5 }"
              :sort="{
                defaultOrder: 'desc',
                field: 'id',
                order: 'asc',
              }"
              :loading.sync="refreshLoading"
            >
              <template slot="action-column" slot-scope="{ row }">
                <b-table-column custom-key="actions" width="110">
                  <b-tooltip v-if="checkPermission('delete_specification')" :label="$t('delete')" type="is-dark" position="is-right">
                    <b-button
                      outlined
                      size="is-small"
                      class="button-green is-danger mr-5 only-icon"
                      icon-left="close-circle"
                      @click="deleteSpecification(row.id)"
                    />
                  </b-tooltip>
                  <b-button
                    v-if="checkPermission('edit_specification')"
                    outlined
                    size="is-small"
                    class="button-purble btn-details"
                    icon-left="arrow-right-bold"
                    tag="router-link"
                    :to="{ name: 'specifications.edit', params: { id: row.id }}"
                  >
                    {{ $t('edit') }}
                  </b-button>
                </b-table-column>
              </template>
              <template slot="header-right">
                <b-tooltip :label="$t('exportExcel')" type="is-dark" position="is-left">
                  <b-button
                    class="filter-button is-hidden-mobile"
                    size="is-circle"
                    icon-left="file-excel"
                    @click="activeTable.excelExport()"
                  />
                </b-tooltip>
              </template>
            </smart-table>
          </b-tab-item>
        </b-tabs>
      </card-component>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Specifications',
  title: ({ $i18n }) => $i18n.t('specifications'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    SmartTable: () => import('@/components/SmartTable'),
  },
  data () {
    return {
      refreshLoading: false,
      isDetailsModalActive: false,
      registerId: null,
      activeTab: 0,
    }
  },
  computed: {
    activeTable () {
      if (this.activeTab === 0 && this.$refs.dutyTypesTable) {
        return this.$refs.dutyTypesTable
      }

      if (this.activeTab === 1 && this.$refs.requestUnitsTable) {
        return this.$refs.requestUnitsTable
      }

      if (this.activeTab === 2 && this.$refs.serviceTypesTable) {
        return this.$refs.departmentsTable
      }

      return null
    }
  },
  methods: {
    refresh () {
      this.activeTable?.loadData()
    },
    deleteSpecification (id) {
      this.$buefy.dialog.confirm({
          message: 'Emin misiniz?',
          cancelText: this.$t('no'),
          confirmText: this.$t('yes'),
          type: 'is-danger',
          onConfirm: () => {
            this.$http
              .delete('specifications/' + id)
              .then(() => {
                this.$buefy.toast.open({
                  message: this.$t('success'),
                  type: 'is-warning'
                })
                this.isDetailsModalActive = false
                this.refresh()
              })
              .catch(() => {
                this.$buefy.toast.open({
                  message: 'Kullanımda olan tanımlamalar silinemez.',
                  type: 'is-danger'
                })
              })
          }
      })
    },
    registerDetails (id) {
      this.registerId = id;
      this.isDetailsModalActive = true;
    },
    specificationDetails (id) {
      this.leadShuttleId = id;
      this.isDayDetailsModalActive = true;
    },
  }
}
</script>

<style>
  .specifications-list .table-wrapper.has-sticky-header {
    height: calc(100vh - 487px) !important;
  }
</style>
